import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const textFieldTypographyStyle = {
    body1: {
        fontSize: '13px',
        '& span': {
            fontWeight: '400',
        }
    }
}

export const TextFieldTypography = withStyles(textFieldTypographyStyle)(
    Typography
)